// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { DoubleListSelector } from './double-list-selector';
import { getComponent } from './common';

/**
 * @class Jsw.EnhancedDoubleListSelector
 * @extends Jsw.DoubleListSelector
 */
export const EnhancedDoubleListSelector = Class.create(DoubleListSelector, {
    _initComponentElement() {
        this._componentElement = $(this._applyTargetId);
        this._componentElement.addClassName('edls');

        const searchControlUnselected = this._isSearchable ? this._getSearchControl('unselected') : '';
        const searchControlSelected = this._isSearchable ? this._getSearchControl('selected') : '';

        const listHtml = '' +
            '<div class="edls-wrap">' +
                '<div class="edls-box edls-box-first">' +
                    '<div class="edls-header">' +
                        `<div class="edls-header-title">${this.lmsg('unselectedTitle')}</div>` +
                    '</div>' +
                    `<div class="edls-box-wrap">${searchControlUnselected}` +
                        '<div class="edls-box-body">' +
                            `<ul class="edls-list" id="${this._id}-unselected"></ul>` +
                            `<div class="edls-list-empty" style="display: none;"><span>${this.lmsg('unselectedEmpty')}</span></div>` +
                            `<div class="edls-ajax-loading" style="display: none;"><span class="ajax-loading">${this.lmsg('loadingTitle')}</span></div>` +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="edls-control">' +
                    '<div class="edls-control-wrap">' +
                        '<div class="edls-control-body">' +
                            '<div class="edls-control-text">' +
                                `<div class="edls-control-text-none">${this.lmsg('controlTextNone')}</div>` +
                                `<div class="edls-control-text-first">${
                                    this.lmsg('controlTextFirst', { checked: `<b>${this.lmsg('controlChecked', { count: '<span class="edls-count">0</span>' })}</b>` })
                                }</div>` +
                                `<div class="edls-control-text-second">${
                                    this.lmsg('controlTextSecond', { checked: `<b>${this.lmsg('controlChecked', { count: '<span class="edls-count">0</span>' })}</b>` })
                                }</div>` +
                            '</div>' +
                            '<div class="edls-control-indicator"><i></i></div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="edls-box edls-box-second">' +
                    '<div class="edls-header">' +
                        `<div class="edls-header-title">${this.lmsg('selectedTitle')}</div>` +
                    '</div>' +
                    `<div class="edls-box-wrap">${searchControlSelected}` +
                        '<div class="edls-box-body">' +
                            `<ul class="edls-list" id="${this._id}-selected"></ul>` +
                            `<div class="edls-list-empty" style="display: none;"><span>${this.lmsg('selectedEmpty')}</span></div>` +
                            `<div class="edls-ajax-loading" style="display: none;"><span class="ajax-loading">${this.lmsg('loadingTitle')}</span></div>` +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this._updateComponentElement(listHtml);
        this._initList();
    },

    _initList($super) {
        $super();

        this._fixListZebra();
    },

    _fixListZebra() {
        [$(`${this._id}-unselected`), $(`${this._id}-selected`)].forEach(function (list) {
            let count = 0;
            list.select('.edls-item').each(function (el) {
                if (el.visible()) {
                    el.addClassName(count % 2 ? 'odd' : 'even');
                    el.removeClassName(count % 2 ? 'even' : 'odd');
                    count++;
                }
            });
            list.next('.edls-list-empty')[count ? 'hide' : 'show']();
        });
    },

    _getSearchControl(columnId) {
        const html =
            '<div class="edls-search">' +
                '<span class="edls-check"><input type="checkbox" value="" class="checkbox"></span>' +
                '<span class="edls-search-control">' +
                    '<input type="text" value="" autocomplete="off" class="search-input search-empty"' +
                        ` id="${this._id}-search-${columnId}"` +
                        ` onfocus="Jsw.getComponent('${this._id}').onFocus(this)"` +
                        ` onblur="Jsw.getComponent('${this._id}').onBlur(this)"` +
                        ` onkeyup="Jsw.getComponent('${this._id}').onToggleSearch('${columnId}', this.value);"` +
                        '>' +
                    `<input type="image" src="${Jsw.skinUrl}/images/search-input.png" class="search-button"` +
                        ` id="${this._id}-search-button-${columnId}"` +
                        ` onmousedown="Jsw.getComponent('${this._id}').onResetSearch('${columnId}');"` +
                        ' onclick="return false;"' +
                        '>' +
                '</span>' +
            '</div>';

        return html;
    },

    _toggleSearchButtonIcon(columnId, isActive) {
        const inputIcon = $(`${this._id}-search-button-${columnId}`);
        inputIcon.toggleClassName('search-button-clear', isActive);
        inputIcon.src = (isActive)
            ? `${Jsw.skinUrl}/images/clear-search.png`
            : `${Jsw.skinUrl}/images/search-input.png`;
    },

    onFocus(element) {
        element.removeClassName('search-empty');
    },

    _resetSearchControl(element) {
        element.value = '';
        element.addClassName('search-empty');
    },

    _initListItem(element, index, isSelected) {
        let container = null;
        let isHidden = false;
        if (isSelected) {
            container = $(`${this._id}-selected`);
            isHidden = !element.selected;
        } else {
            container = $(`${this._id}-unselected`);
            isHidden = element.selected;
        }

        const itemCheckbox = new Element('input', {
            type: 'checkbox',
            class: 'checkbox',
            value: '',
        });

        const item = new Element('div', {
            class: 'edls-item-wrap',
        })
            .insert(new Element('span', { class: 'edls-check' }).insert(itemCheckbox))
            .insert(`<span class="edls-text">${this._getItemText(element)}</span>`);

        const listItem = new Element('li', {
            id: `${this._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`,
            class: 'edls-item',
        })
            .insert(item);

        container.insert(listItem);
        const context = this;
        listItem.observe('click', function (event) {
            context._toggleItemSelection(index, isSelected, event);
        });
        itemCheckbox.observe('click', function (event) {
            event.stopPropagation();
            context._toggleItemCheckbox(itemCheckbox, itemCheckbox.checked);
        });
        if (isHidden) {
            listItem.hide();
        }
    },

    _getItemText(element, highlight) {
        let itemIcons = '';
        if (element.icons && element.icons.length) {
            element.icons.each(function (icon) {
                itemIcons += `<i class="icon"><img src="${Jsw.skinUrl}${icon.src}" title="${icon.title}"></i>`;
            });
            itemIcons += ' ';
        }
        let itemText = element.title.escapeHTML();
        if (highlight) {
            const resultPos = itemText.indexOf(highlight);
            if (resultPos !== -1) {
                itemText = `${itemText.substr(0, resultPos)
                }<b class="search-result-label">${
                    itemText.substr(resultPos, highlight.length)
                }</b>${
                    itemText.substr(resultPos + highlight.length)}`;
            }
        }

        return itemIcons + itemText;
    },

    onToggleSearch(columnId, searchString) {
        const isSelected = (columnId === 'selected');
        searchString = searchString.strip().toLowerCase();

        if (searchString.length) {
            this._toggleSearchButtonIcon(columnId, true);
            this._list.each(function (element, index) {
                const item = $(`${this._id}-${index}-${columnId}-item`);
                if (this._isSearchMatched(element, searchString)) {
                    item.down('.edls-text').update(this._getItemText(element, searchString));
                    if (isSelected === element.selected) {
                        item.show();
                    }
                } else {
                    item.down('.edls-text').update(this._getItemText(element));
                    const checkbox = item.down('.edls-check input');
                    if (item.visible() && checkbox.checked) {
                        this._toggleItemCheckbox(checkbox, false);
                    }
                    item.hide();
                }
            }, this);
        } else {
            this._toggleSearchButtonIcon(columnId, false);
            this._showAllItems(columnId);
        }
    },

    _showAllItems(columnId) {
        const isSelected = (columnId === 'selected');
        this._list.each(function (element, index) {
            const item = $(`${this._id}-${index}-${columnId}-item`);
            item.down('.edls-text').update(this._getItemText(element));
            if (isSelected === element.selected) {
                item.show();
            }
        }, this);
    },

    _toggleItemSelection(index, isSelected, event, batchMode) {
        event.preventDefault();
        this._list[index].selected = !isSelected;
        this._updateElement(this._list[index]);
        $(`${this._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`).hide();
        $(`${this._id}-${index}-${isSelected ? 'unselected' : 'selected'}-item`).show();
        this._toggleItemCheckbox($(`${this._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`).down('.edls-check input'), false);
        if (!batchMode) {
            this._fixListZebra();
            this.onChange();
        }
    },

    _toggleItemCheckbox(checkbox, value) {
        checkbox.checked = value;

        const side = checkbox.up('.edls-box-first') ? 'first' : 'second';
        const count = checkbox.up(`.edls-box-${side}`).select('.edls-list .edls-check input:checked').length;
        if (value) {
            checkbox.up('.edls-item').addClassName('selected');
        } else {
            checkbox.up('.edls-item').removeClassName('selected');
            checkbox.up('.edls-box').down('.edls-search .checkbox').checked = false;
        }
        checkbox.up('.edls')[count ? 'addClassName' : 'removeClassName'](`edls-selected-${side}`);
        checkbox.up('.edls').down(`.edls-control-text-${side} .edls-count`).update(count);
    },

    _updateSelectControls(isSelected, setMarked) {},

    _addEvents() {
        const context = this;
        const componentElement = this._componentElement;

        this._componentElement.select('.edls-box-wrap').each(function (el) {
            el.observe('mouseover', function () {
                componentElement.addClassName('edls-over');
                componentElement.addClassName(this.up('.edls-box-first') ? 'edls-over-first' : 'edls-over-second');
                componentElement.removeClassName(this.up('.edls-box-first') ? 'edls-over-second' : 'edls-over-first');
            });
            el.observe('mouseleave', function () {
                if (!componentElement.hasClassName('edls-selected-first') && !componentElement.hasClassName('edls-selected-second')) {
                    componentElement.removeClassName('edls-over');
                    componentElement.removeClassName('edls-over-first');
                    componentElement.removeClassName('edls-over-second');
                }
            });
        });

        this._componentElement.observe('mouseleave', function () {
            this.removeClassName('edls-over');
            this.removeClassName('edls-over-first');
            this.removeClassName('edls-over-second');
        });

        this._componentElement.select('.edls-box .edls-search .edls-check input').each(function (element) {
            element.observe('click', function () {
                const value = this.checked;
                this.up('.edls-box').select('.edls-list .edls-check input').each(function (checkbox) {
                    if (value && checkbox.up('.edls-item').visible()) {
                        context._toggleItemCheckbox(checkbox, true);
                    } else {
                        context._toggleItemCheckbox(checkbox, false);
                    }
                });
            });
        });

        this._componentElement.select('.edls-control-wrap').first().observe('click', function (event) {
            let isSelected;
            if (componentElement.hasClassName('edls-over-first')) {
                isSelected = false;
            } else if (componentElement.hasClassName('edls-over-second')) {
                isSelected = true;
            } else {
                return;
            }

            context._list.each(function (element, index) {
                if (element.selected === isSelected) {
                    const item = $(`${context._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`);
                    if (item.hasClassName('selected')) {
                        context._toggleItemSelection(index, isSelected, event, true);
                    }
                }
            });
            context._fixListZebra();
            context.onChange();
        });
    },

    _onReloadCreate() {
        this._list = $A();
        this._componentElement.select('.edls-box').each(function (listArea) {
            listArea.select('ul').first().update();
            listArea.select('.edls-ajax-loading').first().show();
            listArea.select('.edls-list-empty').first().hide();
        });
    },

    _onReloadComplete() {
        this._componentElement.select('.edls-box').each(function (listArea) {
            listArea.select('.edls-ajax-loading').first().hide();
        });
    },
});



// WEBPACK FOOTER //
// ./jsw/enhanced-double-list-selector.js